// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1mbcx","content":"GlobalSearch_content__2hKWA"};